<template>
  <div class="WhereUseTableComponent DataTables">
    <p>{{lang.infotext_1}}:</p>

    <div v-show="isData" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'

export default {
  name: 'WhereUseTableComponent',
  props:{
    lang: Object,
    parent: String
  },
  components: {
    LoaderComponent

  },
  data () {
      return {
        name: 'WhereUseTableComponent',
        mainTable: "",
        id: "WhereUseTableComponent" + this._uid,
        columns: [],
        colsAssign: [],
        projects: [],
        isData: false,
        
      }
  },
  computed: {
    ...mapGetters([
      'selectedRevisionRow',

    ]),
    revisionId(){

      if (this.parent == "bom"){
        return this.$store.getters.selectedPartBomRow.revisionId;
      }
      // if (this.$route.query.revisionId != undefined) {
        
      //   return this.$route.query.revisionId;
      // }
      // if (this.$store.getters.selectedRows[0] != undefined) {
        
      //   return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
      // }
      if (this.$route.path == "/PartManager/PartTable" || this.$route.path == "/LibraryManager/LibraryTable") {
        if (this.$store.getters.selectedRows[0] != undefined) {

          if (this.$route.query.revisionId != undefined) {

            return this.$route.query.revisionId;
          }
          if (this.$store.getters.selectedRows[0] != undefined) {

            return this.$store.getters.selectedRows[0].col___revisionId.revisionId;
          }

        }
      }
      if (this.$route.path == "/PartManager/PartDetails" || this.$route.path == "/LibraryManager/LibraryDetails") {
        if (this.selectedRevisionRow[0] != undefined) {
          return this.selectedRevisionRow[0].revisionId;
        }

      }
      return ""


      

    },
    elementId() {

      
      if (this.$route.query.id != undefined) {
        
        return this.$route.query.id;
      }
      if (this.$store.getters.selectedRows[0] != undefined) {
        if (this.$store.getters.sectionPrefix == "pm") {

          return this.$store.getters.selectedRows[0].col___revisionId.partId;
        }
        if (this.$store.getters.sectionPrefix == "lm") {
          return this.$store.getters.selectedRows[0].col___revisionId.libraryId;
        }
        
      }
      return ""

    },
    
    reloadedAfterActionComplex(){
        return this.$store.getters.reloadedAfterActionComplex;
    }

  },
  created () {

    this.createTable();


  },
  watch: {
    revisionId: {
      handler: function(){
        
        this.createTable();
      },
      deep: true
    
      
    },
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.createTable();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },

  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    createTable() {
      this.isData = false;
      let vue = this;
      let action = "";
      let obj = {};
      if (this.parent == "bom") {
        
        if (this.$store.getters.selectedPartBomRow.libraries === true) {
          
          obj.libraryRevisionId = this.$store.getters.selectedPartBomRow.revisionId;
          action = "lm";
        } else {
          obj.partRevisionId = this.$store.getters.selectedPartBomRow.revisionId;
          action = "pm";
        }
        
        obj.projectId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;
        
        
      }else{
        if (this.$store.getters.sectionPrefix == "lm"){
          obj.libraryRevisionId = this.revisionId;
          action = this.$store.getters.sectionPrefix;
        }
        if (this.$store.getters.sectionPrefix == "pm"){
          obj.partRevisionId = this.revisionId;
          action = this.$store.getters.sectionPrefix;
        }
        if (this.$store.getters.sectionPrefix == "projm"){
          obj.partRevisionId = this.revisionId;
          action = this.$store.getters.sectionPrefix;
        }
        
        
      }
      
      
      this.$store.dispatch(action + "_whereUse", obj)
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){

          this.projects = result.data;
          vue.isData = true;  
          


          vue.buildColumns();


        }else{
            vue.isData = false;  
        }


      })
    },
    buildColumns(){

      this.columns = [
        {
          name: "Id",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Project,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Revision,
          alignInColumn: "left",
          type: "taxt"
        },
        {
          name: this.lang.table_header_Variant,
          alignInColumn: "left",
          type: "taxt"
        },
        {
          name: this.lang.table_header_Quantity,
          alignInColumn: "left",
          type: "taxt"
        },
        {
          name: this.lang.table_header_When,
          alignInColumn: "left",
          type: "text"
        },
        
      ]

      this.colsAssign =  [
        { "data": "projectId" },
        { "data": "projectName" },
        { "data": "projectRevision" },
        { "data": "variant" },
        { "data": "quantity" },
        { "data": "projectDate"},
               
      ]

      this.buildTable();
    },
    buildTable(){
          
      var tableplace = document.getElementById(this.id);
      if (tableplace == null){
        return;
      }

      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var table = document.createElement("table");
      table.setAttribute("id", "t_" + this.id);
      table.setAttribute("style", "width:100%");
      table.setAttribute("class", "table table-striped table-bordered");
      tableplace.appendChild(table)

      var tr = document.createElement("tr");
      tr.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr);
      table.appendChild(thead);

      var _vue = this;


      let columnDefs = [];
      var len = this.columns.length;
      for (var i = 0; i < len; i++){

        var el = {};

        var classname = '_dt-body-'+ this.columns[i].alignInColumn;

        el = {
          targets: i,
          className: classname,

          render: function ( data, type, row, meta ) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

            
            if (meta.col == 5){
                return Tools.longDateToShort(data);
            }

            return data;
          }


        }

        columnDefs.push(el);


        var th = document.createElement("th");
        tr.appendChild(th);
        //var p = document.createElement("p");
        //th.appendChild(p);
        var br = document.createElement("br");
        th.appendChild(br);
        var tx = document.createTextNode(this.columns[i].name)
        th.appendChild(tx);

      }


      var option = {};
      option.paging = true;
      option.info = true;
      option.dom = '<fr<t>ip>';
      option.data= this.projects;
      option.myColumnFormats = this.columns;
      option.select = true;
      option.order = [[1, "asc"]];
      option.lengthMenu = [[20]];
      option.columns = this.colsAssign;

      option.columnDefs = columnDefs;
      option.initComplete = function () {


        

      }




      if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
          this.mainTable.destroy();
          
      }

      var _vue = this;

      this.mainTable = $('#t_'+this.id).DataTable(option);

      this.mainTable.columns.adjust().draw();

      //hide first column in table
      this.mainTable.column( 0 ).visible( false );

      let _mainTable = this.mainTable;

      this.mainTable
        .on( 'select', function ( e, dt, type, indexes ) {

          var rowData = _mainTable.rows( indexes ).data();
          

          //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedProjectRow", rowData[0])

        })
        .on( 'deselect', function ( e, dt, type, indexes ) {
          

          //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedProjectRow");
        })

      $('#t_'+this.id +" tbody").on('dblclick', 'tr', function () {

            
        let rowData = _mainTable.rows( this._DT_RowIndex ).data();

        _vue.goTo(rowData[0]);

        
              
      });


      //search input change view
      var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }
      searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm")


    },
    goTo(goalObj){
      
      let elemId = this.elementId;
      
      let from = "/PartManager/PartTable";

      let to = "/ProjectManager/ProjectDetails";
      
     
      let obj = {
        col___revisionId: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          userId: goalObj.userId,
          value: {
            display: goalObj.revisionId
          }
        },
        col___revision: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          value: {
            display: goalObj.revision
          }
        },
        col___status: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          value: {
            display: ""
          }

        },
        col___name: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          value: {
            display: ""
          }

        },
        col___image: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          value: {
            display: ""
          }
        },
        col___projectType: {
          revisionId: goalObj.projectRevisionId,
          projectId: goalObj.projectId,
          value: {
            display: ""
          }
        }
      }

      
      
      const goToObj = {
        to: {
          path: to,
          revisionId: goalObj.projectRevisionId,
          id: goalObj.projectId
        },
        back: {
          path: from,
          revisionId: this.revisionId,
          id: this.$store.getters.selectedRows[0].col___revisionId.partId
        },
        bom: {
          
        }
      }
      this.$store.dispatch("goTo", goToObj);
      


      const query = {
        from: this.$route.path,
        to: to,
        revisionId: goalObj.projectRevisionId,
        id: goalObj.projectId,
        sourceId: elemId,
        sourceRevisionId: this.revisionId,
        end: false
      }

      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", obj);

      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

     
      
      this.$router.push({ path: to, query: query });
    },

  }
}
</script>


<style lang="scss">
  .WhereUseTableComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/WhereUseTableComponent.vue